import type React from 'react';
import { useEffect, useRef } from 'react';

export const useOutsideClickListener = (
  onOutsideClick: () => void,
): React.MutableRefObject<HTMLDivElement | null> => {
  const clickRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        clickRef.current &&
        !clickRef.current.contains(event.target as Node)
      ) {
        onOutsideClick();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onOutsideClick]);

  return clickRef;
};
